<template>
  <div class="fondo">
    <main class="main">
      <slot></slot>
    </main>
  </div>
</template>
<script>
export default {
  name: 'HomeLayout'
}
</script>
